import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from 'react-icons/fa';

import { company } from '../data/siteData';

function Contact() {
  const form = useRef();

  const [status, setStatus] = useState('');
  const [statusType, setStatusType] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    setStatus('Sending...');
    setStatusType('');

    emailjs
      .sendForm(
        'service_2h66yba',
        'template_0wajysf',
        form.current,
        'nuewMmpbwuER0a8xS'
      )
      .then(
        () => {
          setStatus('✅ Message Sent Successfully!');
          setStatusType('success');

          e.target.reset();
        },
        (error) => {
          setStatus('❌ Failed to Send Message!');
          setStatusType('error');

          console.log(error.text);
        }
      );
  };

  return (
    <section className="section" id="contact">
      <div className="container contact-grid">
        <div>
          <p className="section-subtitle">Contact Us</p>

          <h2 className="section-title">
            Let’s Build Something Great Together
          </h2>

          <p className="section-text">
            Have a project idea or need a reliable technology
            partner? Contact our team today and let’s discuss
            your next software solution.
          </p>

          <div className="contact-list">
            <div className="contact-item">
              <FaEnvelope />
              <span>{company.email}</span>
            </div>

            <div className="contact-item">
              <FaPhoneAlt />
              <span>{company.phone}</span>
            </div>

            <div className="contact-item">
              <FaMapMarkerAlt />
              <span>{company.location}</span>
            </div>
          </div>
        </div>

        <form
          ref={form}
          onSubmit={sendEmail}
          className="contact-form"
        >
          <input
            type="text"
            name="user_name"
            placeholder="Your Name"
            required
          />

          <input
            type="email"
            name="user_email"
            placeholder="Your Email"
            required
          />

          <input
            type="text"
            name="subject"
            placeholder="Subject"
            required
          />

          <textarea
            rows="6"
            name="message"
            placeholder="Tell us about your project"
            required
          ></textarea>

          <button
            type="submit"
            className="btn btn-primary full-width"
          >
            Send Message
          </button>

          {status && (
            <p
              style={{
                marginTop: '15px',
                padding: '12px',
                borderRadius: '8px',
                fontWeight: '600',
                color:
                  statusType === 'success'
                    ? '#155724'
                    : '#721c24',
                backgroundColor:
                  statusType === 'success'
                    ? '#d4edda'
                    : '#f8d7da',
                border:
                  statusType === 'success'
                    ? '1px solid #c3e6cb'
                    : '1px solid #f5c6cb',
              }}
            >
              {status}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}

export default Contact;